import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Profile from "./Profile";
import Login from "./Login";
import ListClients from "./ListClients";
import AddClient from "./AddClient";
import CreateDevis from "./CreateDevis";
import ListDevis from "./ListDevis";
// import EditDevis from "./EditDevis"; // Non utilisé pour le moment
import { SidebarSimple } from "@phosphor-icons/react";

function App() {
  const [page, setPage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const pageTitles = {
    "": "Accueil",
    profile: "Profil",
    addClient: "Créer un client",
    listClients: "Liste des clients",
    createDevis: "Créer un devis",
    listDevis: "Liste des devis",
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    setPage(""); // optionnel : réinitialise la page sélectionnée
  };

  if (!isLoggedIn) {
    return <Login onLogin={() => setIsLoggedIn(true)} />;
  }

  return (
    <div className="app-layout">
      <Sidebar isOpen={isSidebarOpen} onNavigate={setPage} onLogout={handleLogout} />
      <div className={`main-content ${isSidebarOpen ? "" : "collapsed"}`}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 38px", borderBottom: "1px solid #e5e7eb" }}>
          <button
            onClick={() => setIsSidebarOpen((prev) => !prev)}
            style={{
              background: "#fff",
              borderRadius: 6,
              padding: "6px 10px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
             
            }}
            aria-label={isSidebarOpen ? "Fermer la barre latérale" : "Ouvrir la barre latérale"}
          >
            <SidebarSimple size={22} weight="duotone" />
          </button>
          <span style={{ width: 1, height: 16, background: "#e5e7eb", margin: "0 8px" }} />
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ color: "#6b7280" }}>Solution Devis</span>
            <span style={{ color: "#9ca3af" }}>›</span>
            <span style={{  }}>{pageTitles[page]}</span>
          </div>
        </div>
        {page === "profile" && <Profile onLogout={handleLogout} />}
        {page === "listClients" && <ListClients />}
        {page === "addClient" && <AddClient />}
        {page === "createDevis" && <CreateDevis />}
        {page === "listDevis" && <ListDevis />}
        {page === "" && <div style={{textAlign: "center", marginTop: "4rem"}}>Bienvenue sur Solution Devis !</div>}
      </div>
    </div>
  );
}

export default App;